<template>
  <div class="-mx-6 -mb-6">
    <div
      @click="prompt()"
      class="text-center p-4 bb-pwa-ath-button"
      v-if="(event || (isIOS() && isSafari())) && !isStandalone()"
    >
      Add To Home Screen
    </div>
    <div class="fixed bottom-0 text-center mx-2 mb-2 p-2 rounded bg-gray-200" style="z-index: 99999" v-if="iosPopupVisible" @click="iosPopupVisible = false">
      Install this app on your device: tap
      <svg class="inline w-8 h-8" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Uploaded to SVGRepo https://www.svgrepo.com -->
        <title>ic_fluent_share_ios_48_filled</title>
        <desc>Created with Sketch.</desc>
        <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="ic_fluent_share_ios_48_filled" fill="#212121" fill-rule="nonzero">
            <path d="M37.75,20.25 C38.6681734,20.25 39.4211923,20.9571103 39.4941988,21.8564728 L39.5,22 L39.5,36.25 C39.5,39.3517853 37.0439828,41.879937 33.9705557,41.9958479 L33.75,42 L14.25,42 C11.1482147,42 8.62006299,39.5439828 8.50415208,36.4705557 L8.5,36.25 L8.5,22 C8.5,21.0335017 9.28350169,20.25 10.25,20.25 C11.1681734,20.25 11.9211923,20.9571103 11.9941988,21.8564728 L12,22 L12,36.25 C12,37.440864 12.9251616,38.4156449 14.0959512,38.4948092 L14.25,38.5 L33.75,38.5 C34.940864,38.5 35.9156449,37.5748384 35.9948092,36.4040488 L36,36.25 L36,22 C36,21.0335017 36.7835017,20.25 37.75,20.25 Z M23.4989075,6.26787884 L23.6477793,6.25297693 L23.6477793,6.25297693 L23.8225053,6.25140103 L23.8225053,6.25140103 L23.9770074,6.26441014 L23.9770074,6.26441014 L24.1549097,6.29667263 L24.1549097,6.29667263 L24.223898,6.31492315 L24.223898,6.31492315 C24.4192207,6.36884271 24.6069182,6.4577966 24.7773762,6.58126437 L24.8968901,6.67628678 L24.8968901,6.67628678 L24.989825,6.76256313 L32.7679996,14.5407377 C33.4514171,15.2241552 33.4514171,16.3321939 32.7679996,17.0156115 C32.1247831,17.6588279 31.1054316,17.6966642 30.4179639,17.1291203 L30.2931259,17.0156115 L25.5,12.222 L25.5,31.5 C25.5,32.4181734 24.7928897,33.1711923 23.8935272,33.2441988 L23.75,33.25 C22.8318266,33.25 22.0788077,32.5428897 22.0058012,31.6435272 L22,31.5 L22,12.226 L17.2116504,17.0156115 C16.5684339,17.6588279 15.5490824,17.6966642 14.8616148,17.1291203 L14.7367767,17.0156115 C14.0935602,16.372395 14.055724,15.3530435 14.6232679,14.6655758 L14.7367767,14.5407377 L22.488804,6.78678454 C22.5446792,6.72871358 22.6045271,6.67449255 22.6679103,6.62455868 L22.7812362,6.54379243 L22.7812362,6.54379243 C22.8189499,6.51724 22.858413,6.49312256 22.8988638,6.47056335 L22.9176605,6.46138558 C23.0947495,6.36422067 23.2909216,6.29776289 23.4989075,6.26787884 Z" id="🎨-Color"></path>
          </g>
        </g>
      </svg>
      and then Add to homescreen
    </div>
  </div>
</template>

<script>
export default {
  name: "AddToHomeScreen",
  data() {
    return {
      event: null,
      iosPopupVisible: false,
    };
  },
  methods: {
    prompt() {
      if (this.isIOS()) {
        this.iosPopupVisible = true;
      } else {
        this.event.prompt();
      }
    },
    isIOS() {
      return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    },
    isStandalone() {
      return ("standalone" in window.navigator) && (window.navigator.standalone)
    },
    isSafari() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
    }
  },
  mounted() {
    window.addEventListener("receive_deferred_prompt", e => {
      console.log("obj", e.detail);
      this.event = e.detail.event;
    });

    window.dispatchEvent(new CustomEvent("request_deferred_prompt"));
  }
};
</script>

<style>
.bb-pwa-ath-button {
  color: var(--common-pwa-button-color);
  font-size: var(--common-pwa-button-font-size);
  font-weight: var(--common-pwa-button-font-weight);
  line-height: var(--common-pwa-button-line-height);

  background-color: var(--common-pwa-button-background-color);
}
</style>
